// components/admin-dashboard/constants.js
export const COLORS = {
    primary: "#003087",
    secondary: "#FFD100",
    accent: "#DC3545",
    success: "#28A745",
    warning: "#FFC107",
    info: "#17A2B8",
  };
  
  export const CHART_COLORS = [
    COLORS.primary,
    COLORS.secondary,
    COLORS.accent,
    COLORS.success,
    COLORS.info,
  ];